<script setup lang="ts">
import type { CreditSearchCourse } from '@/models/credit-search/api'
import { courseSelectionKey } from '@/models/credit-search/selection'

defineOptions({ name: 'CreditSearchCourseResultTable' })

defineProps<{
  courses: CreditSearchCourse[]
  selectedKeys: ReadonlySet<string>
  selectedInstitutionName: string | null
}>()

const emit = defineEmits<{
  select: [course: CreditSearchCourse]
  remove: [course: CreditSearchCourse]
}>()
</script>

<template>
  <table id="CourseListTable" class="table table-sm">
    <thead>
      <tr>
        <th>Institution</th>
        <th>External Course</th>
        <th colspan="2">La Trobe Course</th>
        <th></th>
      </tr>
    </thead>
    <tbody id="CourseListTableBody">
      <tr v-for="course in courses" :key="courseSelectionKey(course)">
        <td>{{ course.institution_name ?? selectedInstitutionName ?? '== Any ==' }}</td>
        <td>{{ course.external_course_name }}</td>
        <td>{{ course.course_code }}</td>
        <td>{{ course.course_name }}</td>
        <td>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            :class="{ hidden: selectedKeys.has(courseSelectionKey(course)) }"
            @click="emit('select', course)"
          >Select</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            :class="{ hidden: !selectedKeys.has(courseSelectionKey(course)) }"
            @click="emit('remove', course)"
          >Remove</button>
        </td>
      </tr>
      <tr v-if="courses.length === 0">
        <td colspan="5">No results - If you have completed a course not listed, you may still apply for subjects to be assessed for credit.</td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
.hidden {
  display: none;
}

td:last-child {
  white-space: nowrap;
}
</style>
